var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "firebase-notice-log" },
    [
      _c(
        "el-form",
        {
          staticClass: "filter-form",
          attrs: { inline: true },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.search($event)
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "來源" } },
            [
              _c(
                "el-select",
                {
                  attrs: { disabled: _vm.loading, placeholder: "請選擇來源" },
                  model: {
                    value: _vm.filters.source,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "source", $$v)
                    },
                    expression: "filters.source",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "3gtapp", value: "3gtapp" },
                  }),
                  _c("el-option", { attrs: { label: "tc", value: "tc" } }),
                  _c("el-option", {
                    attrs: { label: "guideo", value: "guideo" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Token" } },
            [
              _c("el-input", {
                staticStyle: { width: "240px" },
                attrs: {
                  clearable: "",
                  disabled: _vm.loading,
                  placeholder: "輸入完整 Token",
                },
                model: {
                  value: _vm.filters.token,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.filters,
                      "token",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "filters.token",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "紀錄時間" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetimerange",
                  disabled: _vm.loading,
                  "range-separator": "至",
                  "start-placeholder": "開始時間",
                  "end-placeholder": "結束時間",
                  format: "yyyy-MM-dd HH:mm:ss",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  clearable: "",
                },
                model: {
                  value: _vm.filters.recordedAtRange,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "recordedAtRange", $$v)
                  },
                  expression: "filters.recordedAtRange",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "排序" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100px" },
                  attrs: { disabled: _vm.loading },
                  model: {
                    value: _vm.filters.recordedAtOrder,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "recordedAtOrder", $$v)
                    },
                    expression: "filters.recordedAtOrder",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "新到舊", value: "desc" },
                  }),
                  _c("el-option", { attrs: { label: "舊到新", value: "asc" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "每次載入" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "90px" },
                  attrs: { disabled: _vm.loading },
                  on: { change: _vm.search },
                  model: {
                    value: _vm.limit,
                    callback: function ($$v) {
                      _vm.limit = $$v
                    },
                    expression: "limit",
                  },
                },
                [
                  _c("el-option", { attrs: { value: 10, label: "10 筆" } }),
                  _c("el-option", { attrs: { value: 20, label: "20 筆" } }),
                  _c("el-option", { attrs: { value: 50, label: "50 筆" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { margin: "8px 0 0 8px" } },
            [
              _c("el-button", {
                attrs: {
                  type: "primary",
                  icon: "el-icon-search",
                  loading: _vm.loading,
                  circle: "",
                },
                on: { click: _vm.search },
              }),
              _c("el-button", {
                attrs: {
                  icon: "el-icon-refresh",
                  disabled: _vm.loading,
                  circle: "",
                },
                on: { click: _vm.resetFilters },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          ref: "listContainer",
          staticClass: "list-container",
          on: {
            "&scroll": function ($event) {
              return _vm.handleScroll($event)
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading && _vm.requests.length === 0,
                  expression: "loading && requests.length === 0",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.requests,
                border: "",
                fit: "",
                "highlight-current-row": "",
                size: "mini",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.$index + 1) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "紀錄時間", width: "170" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.recorded_at) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "Request ID",
                  "min-width": "250",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(scope.row.firebase_notification_request_id) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "來源 / 應用程式",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.source))]),
                        _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "info" } },
                          [_vm._v(_vm._s(scope.row.application_name))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "通知標題", "min-width": "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getNotification(scope.row).title || "-"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "通知內容", "min-width": "280" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "content-preview" }, [
                          _vm._v(
                            _vm._s(_vm.getNotification(scope.row).body || "-")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "通知類型", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getMessageData(scope.row).fcmType || "-"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "詳細內容",
                  width: "100",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.showDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 查看 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "load-more" },
            [
              _vm.requests.length
                ? _c("span", [
                    _vm._v(_vm._s("已載入 " + _vm.requests.length + " 筆")),
                  ])
                : _vm._e(),
              !_vm.hasMore && _vm.requests.length
                ? _c("span", [_vm._v("已無更多資料")])
                : !_vm.loading && !_vm.requests.length
                ? _c("span", [_vm._v("查無資料")])
                : _vm._e(),
              _vm.hasMore && _vm.requests.length
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "text", loading: _vm.loading },
                      on: { click: _vm.loadMore },
                    },
                    [_vm._v(" 載入更多 ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Firebase 通知請求詳細資料",
            visible: _vm.detailVisible,
            width: "760px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
            closed: function ($event) {
              _vm.selectedRequest = null
            },
          },
        },
        [
          _vm.selectedRequest
            ? _c(
                "div",
                { staticClass: "request-details" },
                [
                  _c(
                    "el-form",
                    { attrs: { "label-width": "120px", size: "small" } },
                    [
                      _c("el-form-item", { attrs: { label: "Request ID" } }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.selectedRequest
                                .firebase_notification_request_id || "-"
                            )
                          ),
                        ]),
                      ]),
                      _c("el-form-item", { attrs: { label: "紀錄時間" } }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.selectedRequest.recorded_at || "-")
                          ),
                        ]),
                      ]),
                      _c("el-form-item", { attrs: { label: "來源" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.selectedRequest.source || "-")),
                        ]),
                      ]),
                      _c("el-form-item", { attrs: { label: "應用程式" } }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.selectedRequest.application_name || "-")
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c("el-alert", {
                    attrs: {
                      title: "通知請求中的 Token 已遮蔽。",
                      type: "info",
                      closable: false,
                      "show-icon": "",
                    },
                  }),
                  _c("pre", { staticClass: "payload-content" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatPayload(_vm.selectedRequest.request_payload)
                      )
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }